import { render, staticRenderFns } from "./message-header.vue?vue&type=template&id=74b75380&"
import script from "./message-header.vue?vue&type=script&lang=js&"
export * from "./message-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports